import { useCallback, useRef } from 'react'
import { DMNAction } from 'modules/dmn'
import { useAppDispatch } from 'state/store'
import {
  clearNextStepOverride,
  setNextStep,
  setStepsVisibility
} from '../../redux'

export default function useExecuteDMNActions() {
  const dispatch = useAppDispatch()
  const prevOverriddenSteps = useRef<Set<string>>(new Set())

  const executeActions = useCallback(
    (actions: DMNAction[]) => {
      const hiddenStepIdsSet = new Set<string>()
      const shownStepIdsSet = new Set<string>()

      const prioritized = actions.slice().sort((a, b) => {
        if (a.priority === b.priority) {
          return a.action_type === 'show_step' ? 1 : -1
        }
        return (a.priority ?? 0) - (b.priority ?? 0)
      })

      const setNextStepActions: Array<{ current: string; next: string }> = []

      for (const action of prioritized) {
        if (action.action_type === 'hide_step') {
          action.action_data.step_uuids.forEach((uuid) => {
            shownStepIdsSet.delete(uuid)
            hiddenStepIdsSet.add(uuid)
          })
        } else if (action.action_type === 'show_step') {
          action.action_data.step_uuids.forEach((uuid) => {
            hiddenStepIdsSet.delete(uuid)
            shownStepIdsSet.add(uuid)
          })
        } else if (action.action_type === 'set_next_step') {
          setNextStepActions.push({
            current: action.action_data.current_step_uuid,
            next: action.action_data.next_step_uuid
          })
        }
      }

      dispatch(
        setStepsVisibility(
          Array.from(shownStepIdsSet),
          Array.from(hiddenStepIdsSet)
        )
      )

      const newOverriddenSteps = new Set(
        setNextStepActions.map((a) => a.current)
      )

      prevOverriddenSteps.current.forEach((stepUuid) => {
        if (!newOverriddenSteps.has(stepUuid)) {
          dispatch(clearNextStepOverride(stepUuid))
        }
      })

      for (const { current, next } of setNextStepActions) {
        dispatch(setNextStep(current, next))
      }

      prevOverriddenSteps.current = newOverriddenSteps
    },
    [dispatch]
  )

  return { executeActions }
}
